import type { Snippet } from "svelte";

export type ActionState = {
  active?: boolean;
  checked?: boolean;
  disabled?: boolean;
  invalid?: boolean;
  hover?: boolean;
  placeholderShown?: boolean;
  indeterminate?: boolean;

  /**
 *
 *
 */
  isInteractive?: boolean;
};

export type ActionProps = {
  Host: HTMLElement;
  display?: string;
  name?: string;
  children?: Snippet;
  actionState?: ActionState;
};

/**
 *
 */
export const useUpdateActionState = (
  getActionState: () => ActionState,
  getActionElement: () => HTMLElement | undefined,
): (() => void) => {
  return () => {
    const actionState = getActionState();
    const actionElement = getActionElement();
    if (!actionElement) return;

    const style = getComputedStyle(actionElement);
    const getFlag = (p: string): boolean => style.getPropertyValue(p) !== "0";

    const inputElement = actionElement instanceof HTMLInputElement ? actionElement : undefined;

    Object.assign(actionState, {
      active: getFlag("--active"),
      checked: inputElement ? inputElement.checked : getFlag("--checked"),
      disabled: inputElement ? inputElement.disabled : getFlag("--disabled"),
      hover: getFlag("--hover"),
      invalid: getFlag("--invalid"),
      placeholderShown: getFlag("--placeholder-shown"),
      indeterminate: inputElement ? inputElement.indeterminate : getFlag("--indeterminate"),
    });
  };
};
